export const isPdfFileProtected = async (file: File) => {
    return file.text().then((text) => {
        return text.substring(text.lastIndexOf('<<'), text.lastIndexOf('>>')).includes('/Encrypt');
    });
};
